// extracted by mini-css-extract-plugin
module.exports = {"menuContainer":"styles_menuContainer__1rqtA","menuHeading":"styles_menuHeading__HSmnI","closeButton":"styles_closeButton__2EGqQ","links":"styles_links__3r0Qj"};